module.exports = __webpack_public_path__ + "static/008215-bb868f6ef632f9c352b21dc06b97438e.jpg";